import { LegalType } from '../../../domain/legalType';
import { RepresentativeTypes } from '../../../domain/representative-types';
import { useForm } from 'react-hook-form';

interface MerchantDetailForm {
  id: string;
  legal_type: string;
  activity: string;
  business_name: string;
  representative_firstname: string;
  representative_number: string;
  representative_lastname: string;
  representative_type: RepresentativeTypes;
  character: string;
  tax_id: string;
  identifier: number;
}

export const useMerchantDetailForm = () => {
  const { reset, register } = useForm<MerchantDetailForm>();

  return {
    controls: {
      id: register('id'),
      legal_type: register('legal_type'),
      activity: register('activity'),
      business_name: register('business_name'),
      representative_firstname: register('representative_firstname'),
      representative_number: register('representative_number'),
      representative_lastname: register('representative_lastname'),
      representative_type: register('representative_type'),
      character: register('character'),
      tax_id: register('tax_id'),
      identifier: register('identifier'),
    },
    reset
  };
};
